<div *ngIf="params.data && !params.data.editable">
    {{params.data[params.colDef.field]}}
</div>
<div *ngIf="params.data && params.data.editable">
    <textarea type="text" [(ngModel)]="displayTextAreaValue" style="width:100%;"
    placeholder="Place your text here" rows="3" (ngModelChange)="onTextAreaValueInput($event)"></textarea>
    <span class="requiredLabel optional" *ngIf="showValidationError"></span>
    <span class="requiredLabel" *ngIf="currentField === 'comment' && !displayTextAreaValue"></span>
</div>